import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]
  static classes = ["active", "inactive"]

  select(event) {
    this.cardTargets.forEach((card) => {
      if (card === event.currentTarget) {
        card.dataset.selected = "true"
        this._applyClasses(card, true)
      } else {
        card.dataset.selected = "false"
        this._applyClasses(card, false)
      }
    })
  }

  _applyClasses(card, isActive) {
    const inner = card.querySelector("[data-persona-border]")
    if (!inner) return

    if (isActive) {
      inner.classList.remove("border-default")
      inner.classList.add("border-brand")
    } else {
      inner.classList.remove("border-brand")
      inner.classList.add("border-default")
    }
  }
}
